// ValidationActions.js - VERSION CORRIGÉE
import { useState } from 'react';
import { toast } from 'sonner';

const ValidationActions = ({ 
  onApprove, 
  onReject, 
  entityId,
  entityType,
  validationId // ← AJOUT pour le rejet
}) => {
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [actionType, setActionType] = useState(null);

  const handleSubmit = async (isApproved) => {
    if (!isApproved && !comments.trim()) {
      toast.error('Les commentaires sont obligatoires pour le rejet');
      return;
    }

    // VALIDATION DES DONNÉES OBLIGATOIRES
    if (!entityType || !entityId) {
      // console.error(' Données manquantes:', { entityType, entityId });
      toast.error('Données de validation incomplètes');
      return;
    }

    setActionType(isApproved ? 'approve' : 'reject');
    setIsSubmitting(true);

    try {
      // console.log(" ValidationActions - Données:", {
      //   entityType,
      //   entityId,
      //   validationId, // ← AJOUT
      //   comments: comments.trim(),
      //   isApproved
      // });

      if (isApproved) {
        await onApprove(entityType, entityId, comments.trim());
      } else {
        // MAINTENANT validationId est disponible
        await onReject(validationId, comments.trim());
      }
      
      setComments('');
      // console.log("✅ ValidationActions - Succès");
    } catch (error) {
      // console.error("ValidationActions - Erreur:", error);
      toast.error("Erreur lors de l'action de validation");
    } finally {
      setIsSubmitting(false);
      setActionType(null);
    }
  };

  return (
    <div className="card">
      <div className="card-header bg-warning bg-opacity-10">
        <h6 className="mb-0 text-warning">
          <i className="fas fa-shield-check me-2"></i>
          Action de Validation
        </h6>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label htmlFor="validationComments" className="form-label small fw-semibold">
            Commentaires <span className="text-muted fw-normal">(Obligatoires pour le rejet)</span>
          </label>
          <textarea
            id="validationComments"
            className="form-control"
            rows="3"
            placeholder="Ajoutez vos commentaires ici..."
            value={comments}
            onChange={(e) => setComments(e.target.value)}
          />
        </div>

        {/* Debug info temporaire */}
        <div className="alert alert-info alert-sm mb-3">
          <small>
            <strong>Debug:</strong> EntityType: {entityType}, EntityId: {entityId}, ValidationId: {validationId}
          </small>
        </div>

        <div className="alert alert-warning alert-sm mb-3">
          <i className="fas fa-exclamation-triangle me-2"></i>
          <small>Votre décision est définitive et ne peut pas être annulée.</small>
        </div>

        <div className="d-grid gap-2">
          <button
            type="button"
            className="btn btn-success"
            onClick={() => handleSubmit(true)}
            disabled={isSubmitting || !entityType || !entityId}
          >
            {isSubmitting && actionType === 'approve' ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" />
                Approbation...
              </>
            ) : (
              <>
                <i className="fas fa-check-lg me-1"></i>
                Approuver
              </>
            )}
          </button>
          
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleSubmit(false)}
            disabled={isSubmitting || !comments.trim()}
          >
            {isSubmitting && actionType === 'reject' ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" />
                Rejet...
              </>
            ) : (
              <>
                <i className="fas fa-x-lg me-1"></i>
                Rejeter
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidationActions;